import { getLatoFontFamilyByStyle } from '@photosi/rn-components/text/text-lato/TextLato.logic';
import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Theme } from 'src/theme-v2/colors';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { Stroke } from 'src/theme-v2/stroke';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  input: {
    height: 40,
    borderRadius: CornerRadius.Small,
    borderWidth: Stroke.StrokeThickness.StrokeThicknessDefault,
    borderColor: 'transparent',
    paddingVertical: Spacing.Condensed,
    paddingHorizontal: Spacing.Condensed,
    flexDirection: 'row',
    alignItems: 'center',
    gap: Spacing.Condensed,
    cursor: 'pointer',
    marginLeft: Spacing.Condensed * -1,
  },
  inputFocused: {
    borderColor: Theme.main.ThemeWater,
  },
  inputText: {
    ...textLatoStyleDS.BodyRegularMd,
    fontFamily: getLatoFontFamilyByStyle(textLatoStyleDS.BodyRegularMd),
    flex: 1,
    color: ColorTypography.TextColorTertiary,
    cursor: 'pointer',
  },
  inputTextFocused: {
    cursor: 'text',
  },
  hiddenText: {
    position: 'absolute',
    ...textLatoStyleDS.BodyRegularMd,
    opacity: 0,
    zIndex: -1,
  },
});
